import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
export function enforceBasePath(appId, mfId) {
  // eslint-disable-next-line no-console
  console.log("[".concat(mfId, "] boot from:"), globalThis.location.pathname);
  window.imXv = {
    appId: appId,
    injectedMfs: {}
  };
  if (mfId !== 'app') {
    window.imXv.injectedMfs[mfId] = true;
  }
  var basePath = "/".concat(appId, "/").concat(mfId);
  // DEV mode: prevent loading from the root
  if (!globalThis.location.pathname.startsWith(basePath)) {
    // eslint-disable-next-line no-console
    console.info("[".concat(mfId, "] redirect from: \"").concat(globalThis.location.pathname, "\" to: \"").concat(basePath, "\""));
    globalThis.history.replaceState(null, '', basePath);
    globalThis.location.reload();
  }
}
export function getAppId() {
  return window.imXv.appId;
}

/** Loads script in head with cache bust */
export function loadScript(url) {
  return new Promise(function (resolve, reject) {
    try {
      var scriptEl = document.createElement('script');
      var queryString = buildNumber || new Date().getTime();
      scriptEl.src = "".concat(url, "?v=").concat(queryString);
      scriptEl.type = 'text/javascript';
      scriptEl.async = true;
      scriptEl.onload = function () {
        return resolve(true);
      };
      scriptEl.onerror = function () {
        return resolve(false);
      };
      document.head.appendChild(scriptEl);
    } catch (e) {
      resolve(false);
    }
  });
}

/** Assumes our deployment folder structure and entry point naming convention. */
function loadMfEntrypoint(appId, mfId) {
  window.imXv.injectedMfs[mfId] = true;
  var url = "/".concat(appId, "/").concat(mfId, "/remote-").concat(mfId, ".js");
  return loadScript(url);
}
export function loadRemotesEntrypoints(_x, _x2) {
  return _loadRemotesEntrypoints.apply(this, arguments);
}
function _loadRemotesEntrypoints() {
  _loadRemotesEntrypoints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(mfIds, appId) {
    var id;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          id = appId != null ? appId : getAppId();
          return _context.abrupt("return", loadMfsEntrypoints(id, mfIds));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _loadRemotesEntrypoints.apply(this, arguments);
}
export function loadMfsEntrypoints(_x3, _x4) {
  return _loadMfsEntrypoints.apply(this, arguments);
}
function _loadMfsEntrypoints() {
  _loadMfsEntrypoints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(appId, mfIds) {
    var promises, scriptsLoaded, i;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          promises = [];
          mfIds.forEach(function (mfId) {
            promises.push(loadMfEntrypoint(appId, mfId));
          });
          _context2.next = 4;
          return Promise.all(promises);
        case 4:
          scriptsLoaded = _context2.sent;
          for (i = 0; i < mfIds.length; i++) {
            if (!scriptsLoaded[i]) {
              console.warn("Remote \"".concat(mfIds[i], "\" not loaded!"));
            }
          }
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _loadMfsEntrypoints.apply(this, arguments);
}
function getMfExposedModuleRaw(_x5, _x6) {
  return _getMfExposedModuleRaw.apply(this, arguments);
}
function _getMfExposedModuleRaw() {
  _getMfExposedModuleRaw = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(mfId, moduleName) {
    var container, factory, mod;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return __webpack_init_sharing__('default');
        case 2:
          container = window[mfId]; // or get the container somewhere else
          if (container) {
            _context3.next = 6;
            break;
          }
          console.warn("Federated container '".concat(mfId, "' not found."));
          return _context3.abrupt("return");
        case 6:
          _context3.prev = 6;
          _context3.next = 9;
          return container.init(__webpack_share_scopes__["default"]);
        case 9:
          _context3.next = 11;
          return window[mfId].get("./".concat(moduleName));
        case 11:
          factory = _context3.sent;
          mod = factory(); // console.log('raw module', mod);
          return _context3.abrupt("return", mod);
        case 16:
          _context3.prev = 16;
          _context3.t0 = _context3["catch"](6);
          console.warn(mfId, "getMfExposedModuleRaw(".concat(mfId, ", ").concat(moduleName, ")"), _context3.t0);
          return _context3.abrupt("return");
        case 20:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[6, 16]]);
  }));
  return _getMfExposedModuleRaw.apply(this, arguments);
}
export function getMfExposedModule(_x7, _x8) {
  return _getMfExposedModule.apply(this, arguments);
}
function _getMfExposedModule() {
  _getMfExposedModule = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(mfId, moduleName) {
    var rawModule, result;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return getMfExposedModuleRaw(mfId, moduleName);
        case 2:
          rawModule = _context4.sent;
          if (!(rawModule && rawModule.__esModule)) {
            _context4.next = 7;
            break;
          }
          result = rawModule[moduleName] || rawModule["default"];
          if (!result) {
            console.warn("Federated esModule '".concat(moduleName, "' has no exports."));
          }
          return _context4.abrupt("return", result);
        case 7:
          return _context4.abrupt("return", rawModule);
        case 8:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _getMfExposedModule.apply(this, arguments);
}
export function getMfOutlet(_x9) {
  return _getMfOutlet.apply(this, arguments);
}
function _getMfOutlet() {
  _getMfOutlet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(mfId) {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return getMfExposedModule(mfId, 'mf-outlet');
        case 2:
          return _context5.abrupt("return", _context5.sent);
        case 3:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _getMfOutlet.apply(this, arguments);
}
export function getMfOutlets(_x10) {
  return _getMfOutlets.apply(this, arguments);
}
function _getMfOutlets() {
  _getMfOutlets = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(mfIds) {
    var promises, mfOutlets;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          promises = [];
          mfIds.forEach(function (mfId) {
            promises.push(getMfOutlet(mfId));
          });
          _context6.next = 4;
          return Promise.all(promises);
        case 4:
          mfOutlets = _context6.sent;
          return _context6.abrupt("return", mfOutlets.filter(Boolean));
        case 6:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _getMfOutlets.apply(this, arguments);
}
export function getMfView(_x11, _x12) {
  return _getMfView.apply(this, arguments);
}
function _getMfView() {
  _getMfView = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(mfId, viewId) {
    var outlet, viewsMap;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return getMfOutlet(mfId);
        case 2:
          outlet = _context7.sent;
          viewsMap = outlet == null ? void 0 : outlet.viewsMap;
          return _context7.abrupt("return", viewsMap ? viewsMap[viewId] : undefined);
        case 5:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _getMfView.apply(this, arguments);
}
export function getMfDialog(_x13, _x14) {
  return _getMfDialog.apply(this, arguments);
}
function _getMfDialog() {
  _getMfDialog = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(mfId, dialogId) {
    var outlet, dialogs;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return getMfOutlet(mfId);
        case 2:
          outlet = _context8.sent;
          dialogs = outlet == null ? void 0 : outlet.dialogs;
          return _context8.abrupt("return", dialogs ? dialogs[dialogId] : undefined);
        case 5:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _getMfDialog.apply(this, arguments);
}
export function getMfWidgetsMap(_x15) {
  return _getMfWidgetsMap.apply(this, arguments);
}
function _getMfWidgetsMap() {
  _getMfWidgetsMap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(mfId) {
    var outlet, result;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return getMfOutlet(mfId);
        case 2:
          outlet = _context9.sent;
          if (outlet) {
            _context9.next = 5;
            break;
          }
          return _context9.abrupt("return");
        case 5:
          if (!outlet.widgetsMap) {
            _context9.next = 7;
            break;
          }
          return _context9.abrupt("return", outlet.widgetsMap);
        case 7:
          if (!outlet.widgets) {
            _context9.next = 11;
            break;
          }
          result = {};
          outlet.widgets.forEach(function (def) {
            if (result[def.id]) {
              console.warn("Widget '".concat(def.id, "' defined twice in ").concat(mfId, "."));
            }
            result[def.id] = def;
          });
          return _context9.abrupt("return", result);
        case 11:
          return _context9.abrupt("return");
        case 12:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _getMfWidgetsMap.apply(this, arguments);
}
export function getDayDifference(fromDate, toDate) {
  var _MS_PER_DAY = 1000 * 60 * 60 * 24;
  var _fromDate = new Date(fromDate.getTime());
  var _toDate = new Date(toDate.getTime());

  //reset time to 12 am
  _fromDate.setHours(0, 0, 0, 0);
  _toDate.setHours(0, 0, 0, 0);
  return Math.floor((_toDate.getTime() - _fromDate.getTime()) / _MS_PER_DAY);
}